import { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";

export const useIsKeyboardOpen = (shouldActivate = false): boolean => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!isMobile) return;
    if (!shouldActivate) return;

    let activeElement: HTMLElement | null = null;

    const handleFocusIn = (e: FocusEvent) => {
      const target = e.target as HTMLElement;

      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
        activeElement = target; // Track the currently focused element
        setIsKeyboardOpen(true);
      }
    };

    const handleFocusOut = (e: FocusEvent) => {
      const target = e.target as HTMLElement;

      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
        // Check if focus has moved to another input or textarea
        if (document.activeElement !== activeElement) {
          setIsKeyboardOpen(false);
        }
      }
    };

    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);

    return () => {
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
    };
  }, [shouldActivate]);

  return isKeyboardOpen;
};
